import { SelectOption } from '@/src/components/atom/Select';
import {
  ArrayFilters,
  DefaultFilters,
  ListFilterTypeObject,
  WithOptionsFilterFilters,
} from '@/src/components/organism/Filter/types';

export const filters: (
  homeContentCategoryOptions: SelectOption[],
) => (
  | DefaultFilters
  | WithOptionsFilterFilters
  | ArrayFilters
)[] = homeContentCategoryOptions => [
  {
    key: 'id',
    label: 'ID',
    placeholder: 'ID를 입력해주세요',
    type: 'TEXT',
  },
  {
    key: 'isExposed',
    label: '노출 여부',
    placeholder: '전체',
    options: [
      { label: '전체', value: '' },
      { label: '노출', value: 'true' },
      { label: '미노출', value: 'false' },
    ],
    type: ListFilterTypeObject.SELECT,
  },
  {
    key: 'isExposeNewBadge',
    label: '뱃지 노출 여부',
    placeholder: '전체',
    options: [
      { label: '전체', value: '' },
      { label: '노출', value: 'true' },
      { label: '미노출', value: 'false' },
    ],
    type: ListFilterTypeObject.SELECT,
  },
  {
    key: 'titleLike',
    label: '제목',
    placeholder: '컨텐츠 제목을 입력해주세요',
  },
  {
    key: 'contentType',
    label: '연결 컨텐츠',
    placeholder: '전체',
    options: homeContentCategoryOptions,
    type: ListFilterTypeObject.SELECT,
  },
  {
    key: 'adminNameLike',
    label: '등록 관리자',
    placeholder: '관리자명을 입력해주세요',
  },
];
